<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <location-form v-if="location"
          @submit="submit"
          :init-location="location"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import LocationForm from './location-form'

export default {
  components: { LocationForm },
  data () {
    return {
      location: null,
      valErrors: []
    }
  },
  methods: {
    async submit (location) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/locations/${location.id}`, location).then(({ data }) => {
        this.$notify({
          message: 'Standort erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/locations')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/locations/${this.$route.params.id}`).then(({ data }) => {
      this.location = data
    })
  }
}
</script>

<style>
</style>
